import { Link } from "react-router-dom";
import { ArrowUpRight, Clock, MapPin } from "lucide-react";
import { buildWaLink } from "@/lib/constants";

export default function PackageCard({ pkg, variant = "default" }) {
  const waMsg = `Hi iExplore, I'd like more details on the "${pkg.title}" (${pkg.duration}) package.`;

  return (
    <article
      data-testid={`package-card-${pkg.slug}`}
      className="group bg-white border border-[#1F3A5F]/10 hover:border-[#1F3A5F]/30 transition-all duration-500 hover:-translate-y-1 flex flex-col"
    >
      <Link
        to={`/packages/${pkg.slug}`}
        className="relative block aspect-[4/3] overflow-hidden bg-[#11233B]"
      >
        <img
          src={pkg.image}
          alt={pkg.title}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover zoom-img"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#1F3A5F]/70 via-[#1F3A5F]/10 to-transparent" />
        <div className="absolute top-4 left-4 bg-[#FAF4ED] text-[#1F3A5F] text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 font-medium">
          {pkg.duration}
        </div>
        {pkg.is_featured && (
          <div className="absolute top-4 right-4 bg-[#E8B89B] text-[#1F3A5F] text-[10px] uppercase tracking-[0.22em] px-3 py-1.5 font-medium">
            Featured
          </div>
        )}
      </Link>

      <div className="p-7 md:p-8 flex flex-col flex-1">
        <p className="eyebrow mb-3">{pkg.theme.split("|")[0].trim()}</p>
        <h3 className="font-serif text-2xl md:text-3xl text-[#1F3A5F] leading-snug">
          {pkg.title}
        </h3>
        <p className="text-sm text-[#5A6B82] mt-3">{pkg.subtitle}</p>

        <div className="flex items-center gap-5 mt-5 text-xs text-[#5A6B82]">
          <span className="inline-flex items-center gap-1.5">
            <Clock size={13} strokeWidth={1.5} /> {pkg.nights}N · {pkg.days}D
          </span>
          <span className="inline-flex items-center gap-1.5">
            <MapPin size={13} strokeWidth={1.5} /> Ladakh
          </span>
        </div>

        {variant !== "compact" && (
          <ul className="mt-6 space-y-2 border-t border-[#1F3A5F]/10 pt-6 text-sm text-[#11233B]/80">
            {pkg.highlights.slice(0, 3).map((h) => (
              <li key={h} className="flex gap-3">
                <span className="text-[#E8B89B] mt-1">—</span>
                <span>{h}</span>
              </li>
            ))}
          </ul>
        )}

        <div className="mt-auto pt-7 flex items-center justify-between gap-4">
          <div>
            <p className="text-[10px] uppercase tracking-[0.22em] text-[#5A6B82]">
              From
            </p>
            <p className="font-serif text-2xl text-[#1F3A5F]">
              ₹{pkg.price_from.toLocaleString("en-IN")}
            </p>
          </div>
          <div className="flex items-center gap-2">
            <a
              href={buildWaLink(waMsg)}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`pkg-${pkg.slug}-wa`}
              className="inline-flex items-center gap-1 text-xs uppercase tracking-[0.18em] text-[#5A6B82] hover:text-[#1F3A5F] border-b border-[#1F3A5F]/20 hover:border-[#1F3A5F] py-1"
            >
              WhatsApp
            </a>
            <Link
              to={`/packages/${pkg.slug}`}
              data-testid={`pkg-${pkg.slug}-view`}
              className="inline-flex items-center gap-1 bg-[#1F3A5F] hover:bg-[#11233B] text-[#FAF4ED] px-4 py-3 text-[11px] uppercase tracking-[0.18em] transition-colors"
            >
              View <ArrowUpRight size={14} strokeWidth={1.6} />
            </Link>
          </div>
        </div>
      </div>
    </article>
  );
}
